module.exports = __webpack_public_path__ + "static/media/7.8fd488c5.jpg";